import React, { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [username, setUsername] = useState(() => localStorage.getItem('username') || '');
  const [password, setPassword] = useState('');
 const [nric, setNric] = useState(() => localStorage.getItem('nric') || '');
  const [errorMsg, setErrorMsg] = useState('');
  const [batchNo, setBatchNo] = useState(() => localStorage.getItem('batchNo') || '');
  const [courseId, setCourseIdState] = useState(() => localStorage.getItem('courseId') || '');
  const [canName, setCanName] = useState(() => localStorage.getItem('canName') || '');
  const [courseDate, SetCourseDate] = useState(() => localStorage.getItem('courseDate') || '');
  const [serialNo, setSerialNo] = useState(() => localStorage.getItem('serialNo') || '');
  const [sts, setSts] = useState(() => localStorage.getItem('sts') || '');
  const [examStatus, setExamStatus] =useState(() => localStorage.getItem('examStatus') || '');
  const navigate = useNavigate();
console.log(examStatus);
  // Always sync localStorage
  useEffect(() => localStorage.setItem('username', username), [username]);
  useEffect(() => localStorage.setItem('batchNo', batchNo), [batchNo]);
  useEffect(() => localStorage.setItem('courseId', courseId), [courseId]);
  useEffect(() => localStorage.setItem('canName', canName), [canName]);
  useEffect(() => localStorage.setItem('courseDate', courseDate), [courseDate]);
  useEffect(() => localStorage.setItem('serialNo', serialNo), [serialNo]);
  useEffect(() => localStorage.setItem('sts', sts), [sts]);
  useEffect(() => localStorage.setItem('examStatus', examStatus), [examStatus]);
  useEffect(() => localStorage.setItem('nric', nric), [nric]);

  // ✅ Live sts fetch (polling every 5 seconds)
  useEffect(() => {
    const fetchLatestSts = async () => {
      if (username && password) {
        try {
          const res = await axios.post('https://elearn-api.onrender.com/api/login', {
            username,
            Password: password,
          });
          const newSts = res.data?.[0]?.CurrentSts;
          if (newSts && newSts !== sts) {
            setSts(newSts); // ✅ Update sts in context
          }
        } catch (err) {
          console.error('Error refreshing sts:', err);
        }
      }
    };

    const interval = setInterval(fetchLatestSts, 5000); // ⏱️ every 5 sec
    return () => clearInterval(interval); // cleanup
  }, [username, password, sts]);

  const clearAuth = () => {
    setUsername('');
    setPassword('');
    setErrorMsg('');
    setCourseIdState('');
    setBatchNo('');
    setCanName('');
    localStorage.removeItem('username');
    localStorage.removeItem('password');
    localStorage.removeItem('courseId');
    localStorage.removeItem('batchNo');
    localStorage.removeItem('canName');
    localStorage.removeItem('sts');
    localStorage.removeItem('examStatus');
    localStorage.removeItem('nric');

  };

  return (
    <AuthContext.Provider
      value={{
        username, setUsername,
        password, setPassword,
        errorMsg, setErrorMsg,
        courseId, setCourseId: setCourseIdState,
        batchNo, setBatchNo,
        canName, setCanName,
        clearAuth,
        sts, setSts,
        courseDate, SetCourseDate,
        serialNo, setSerialNo,examStatus,setExamStatus,nric,setNric
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
